import React, { Fragment } from 'react'
import { Box, Grid, IconButton, Tooltip, Typography } from '@mui/material'
import { TicketInfo } from '../../../interfaces/PickingValidate/TicketInfo'
import { useStyles } from './styles'
import { StatesRoutes } from '../../../interfaces/PickingValidate/StatesRoutes'
import { PickingValidateHeader } from '../../../interfaces/Picking/Picking'
import { PickingRouteMissingPieces } from './PickingRouteMissingPieces'
import { eTypePickingRoute } from '../../../enums/eTypePickingRoute'
import { fechaFormateada } from '../../../utils/dateHelper'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'

interface PickingFinishHeaderProps {
  ticketInfo: TicketInfo
  statesRoute: StatesRoutes
  pickingHeader: PickingValidateHeader | undefined
}

export const PickingFinishHeader: React.FC<PickingFinishHeaderProps> = ({
  ticketInfo,
  statesRoute,
  pickingHeader
}) => {
  const classes = useStyles()

  const missingUnitsQty =
    (pickingHeader?.realQty || 0) - (pickingHeader?.pickedQty || 0)

  const getIconWithTooltip = () => {
    return (
      <Tooltip title='Sin LPN'>
        <IconButton>
          <RemoveCircleOutlineIcon />
        </IconButton>
      </Tooltip>
    )
  }
  return (
    <Fragment>
      <Box border={1} borderRadius={10}>
        <Grid
          container
          spacing={2}
          alignContent='center'
          style={{ marginTop: '10px', marginBottom: '5px' }}
        >
          <Grid item xs={12} sm container>
            <Grid item xs={12} container direction='column' spacing={2}>
              <Grid item xs>
                <Typography gutterBottom className={classes.ticketHeader}>
                  {`Ruta de picking: `}{' '}
                  <p
                    style={{
                      display: 'contents',
                      fontWeight: 'bold'
                    }}
                  >
                    {pickingHeader?.typePickingRouteId === eTypePickingRoute.RTV
                      ? `RTV${pickingHeader.pickingRouteId}`
                      : pickingHeader?.pickingRouteId}
                  </p>
                </Typography>
              </Grid>
              <Grid item xs>
                <Typography gutterBottom className={classes.ticketHeader}>
                  {`Tag OT:`}{' '}
                  <p
                    style={{
                      display: 'contents',
                      fontWeight: 'bold'
                    }}
                  >
                    {ticketInfo.workOrderTag}
                  </p>
                </Typography>
              </Grid>
              <Grid item xs>
                <Typography gutterBottom className={classes.ticketHeader}>
                  {`OT: `}
                  <p
                    style={{
                      display: 'contents',
                      fontWeight: 'bold'
                    }}
                  >
                    {pickingHeader?.typePickingRouteId === eTypePickingRoute.RTV
                      ? `RTV${ticketInfo.workOrderId}`
                      : ticketInfo.workOrderId}
                  </p>
                </Typography>
              </Grid>

              <Grid item xs>
                <Typography gutterBottom className={classes.ticketHeader}>
                  {`ID de Pedido: `}
                  <p
                    style={{
                      display: 'contents',
                      fontWeight: 'bold'
                    }}
                  >
                    {pickingHeader?.skuDetail?.[0]?.referenceId}{' '}
                  </p>
                </Typography>
              </Grid>

              <Grid item xs>
                <Typography gutterBottom className={classes.ticketHeader}>
                  {`LPN: `}
                  <p
                    style={{
                      display: 'contents',
                      fontWeight: 'bold'
                    }}
                  >
                    {pickingHeader?.lpn === null
                      ? getIconWithTooltip()
                      : pickingHeader?.lpn}
                  </p>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm container>
            <Grid item xs={12} container direction='column' spacing={2}>
              <Grid item xs>
                <Typography gutterBottom className={classes.ticketHeader}>
                  {`Zona:`}{' '}
                  <p
                    style={{
                      display: 'contents',
                      fontWeight: 'bold'
                    }}
                  >
                    {ticketInfo.zone}
                  </p>
                </Typography>
              </Grid>
              <Grid item xs>
                <Typography gutterBottom className={classes.ticketHeader}>
                  {`Estado de la ruta:`}{' '}
                  <p
                    style={{
                      display: 'contents',
                      color: statesRoute.colorPickingRouteState,
                      fontWeight: 'bold'
                    }}
                  >
                    {statesRoute.pickingRouteState === 'CREADA'
                      ? 'NO INICIADA'
                      : statesRoute.pickingRouteState}
                  </p>
                </Typography>
              </Grid>
              <Grid item xs>
                <Typography gutterBottom className={classes.ticketHeader}>
                  Obs:{' '}
                  {(pickingHeader?.orderCancellationRequest && (
                    <b style={{ color: 'red' }}>SOLICITUD DE CANCELACIÓN</b>
                  )) || (
                    <PickingRouteMissingPieces quantity={missingUnitsQty} />
                  )}
                </Typography>
              </Grid>
              <Grid item xs>
                <Typography
                  gutterBottom
                  className={classes.ticketHeader}
                ></Typography>
              </Grid>
              <Grid item xs>
                <Typography gutterBottom className={classes.ticketHeader}>
                  {`Fecha validación:`}{' '}
                  <p
                    style={{
                      display: 'contents',
                      fontWeight: 'bold'
                    }}
                  >
                    {fechaFormateada(
                      pickingHeader?.validationendedAt,
                      'dd/MM/yyyy hh:mm a'
                    )}
                  </p>
                </Typography>
              </Grid>

              <Grid item xs>
                <Typography gutterBottom className={classes.ticketHeader}>
                  {`Validado por:`}{' '}
                  <p
                    style={{
                      display: 'contents',
                      fontWeight: 'bold'
                    }}
                  >
                    {pickingHeader?.validationUser}
                  </p>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Fragment>
  )
}
